"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.legendSymbol = exports.legendItem = void 0;

var _util = require("../../../util");

const legendItem = () => ({
  margin: '0 13px'
});

exports.legendItem = legendItem;

const legendSymbol = ({
  theme,
  cssProps
}) => ({
  width: '20px',
  height: '20px',
  borderRadius: '4px',
  marginRight: '7px',
  backgroundColor: (0, _util.color)(theme, (cssProps === null || cssProps === void 0 ? void 0 : cssProps.color) || 'background.yellow')
});

exports.legendSymbol = legendSymbol;
//# sourceMappingURL=BarChart.style..js.map